'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var olxPalette = {
  /** grey */
  $01_white: '#FFFFFF',
  $02_gray: '#FAFBFB',
  $03_gray: '#F2F4F5',
  $04_gray: '#D8DFE0',
  $05_gray: '#7F9799',
  $06_gray: '#406367',
  $07_charcoal: '#02282C',
  /**  blue */
  $01_blue_bg_light: '#EBF1FF',
  $02_blue_light: '#CEDDFF',
  $03_blue_tint_light: '#9CBBFF',
  $04_blue_tint_dark: '#6C99FF',
  $05_blue_primary: '#3A77FF',
  $06_blue_dark: '#1D3C81',
  $07_blue_bg_dark: '#17284E',
  /** teal */
  $01_teal_bg_light: '#E9FCFB',
  $02_teal_light: '#C8F8F6',
  $03_teal_tint_light: '#91F2ED',
  $04_teal_tint_dark: '#5AECE4',
  $05_teal_primary: '#23E5DB',
  $06_teal_dark: '#00A49F',
  $07_teal_bg_dark: '#085C5D',
  /**  red */
  $01_red_bg_light: '#FFEEEA',
  $02_red_light: '#FFD6C9',
  $03_red_tint_light: '#FFAA9A',
  $04_red_tint_dark: '#FF8169',
  $05_red_primary: '#FF5636',
  $06_red_dark: '#D02C0D',
  $07_red_bg_dark: '#991801',
  /** yellow */
  $01_yellow_bg_light: '#FFFBEF',
  $02_yellow_light: '#FFF6D9',
  $03_yellow_tint_light: '#FFEDB2',
  $04_yellow_tint_dark: '#FFE48D',
  $05_yellow_primary: '#FFCE32',
  $06_yellow_dark: '#D2B982',
  $07_yellow_bg_dark: '#71674E',
  /** alpha */
  $01_alpha_transparent: 'transparent',
  $01_alpha_shimmer: 'black',
  /** deprecated, use $06_alpha_white_80 */
  $02_alpha_white_60: 'rgba(255, 255, 255, 0.8)',
  /** deprecated, use $02_alpha_black_16 */
  $03_alpha_black_16: 'rgba(0, 0, 0, 0.16)',
  $04_alpha_charcoal_80: 'rgba(0, 47, 52, 0.8)',
  $02_alpha_white_16: 'rgba(255, 255, 255, 0.16)',
  $03_alpha_white_24: 'rgba(255, 255, 255, 0.24)',
  $04_alpha_white_40: 'rgba(255, 255, 255, 0.4)',
  $05_alpha_white_64: 'rgba(255, 255, 255, 0.64)',
  $06_alpha_white_80: 'rgba(255, 255, 255, 0.8)',
  $02_alpha_black_16: 'rgba(0,0,0, 0.16)',
  $03_alpha_black_24: 'rgba(0,0,0, 0.24)',
  $04_alpha_black_48: 'rgba(0,0,0,0.48)',
  $05_alpha_black_64: 'rgba(0,0,0, 0.64)'
};

exports.olxPalette = olxPalette;
//# sourceMappingURL=olxPalette.js.map
